export enum Role {
  ADMIN = 'ROLE_HEALTHCARE_ORGANIZATION_ADMIN',
  USER = 'ROLE_HEALTHCARE_ORGANIZATION_USER',
}
